"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var colorManipulator_1 = require("@material-ui/core/styles/colorManipulator");
var styles = function (theme) { return ({
    root: {
        flexGrow: 1,
    },
    input: {
        display: 'flex',
        padding: 0,
    },
    valueContainer: {
        display: 'flex',
        flexWrap: 'wrap',
        flex: 1,
        alignItems: 'center',
        overflow: 'hidden',
    },
    chip: {
        margin: theme.spacing.unit / 2 + "px " + theme.spacing.unit / 4 + "px",
    },
    chipFocused: {
        backgroundColor: colorManipulator_1.emphasize(theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700], 0.08),
    },
    noOptionsMessage: {
        padding: theme.spacing.unit + "px " + theme.spacing.unit * 2 + "px",
    },
    singleValue: {
        fontSize: 16,
    },
    placeholder: {
        position: 'absolute',
        left: 2,
        fontSize: 16,
    },
    paper: {
        position: 'absolute',
        zIndex: 1,
        marginTop: theme.spacing.unit,
        left: 0,
        right: 0,
    },
    divider: {
        height: theme.spacing.unit * 2,
    },
}); };
exports.default = styles;
//# sourceMappingURL=styles.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@react-form-fields/material-ui/components/Autocomplete/styles.js
// module id = 917
// module chunks = 58